import { decryptAES, encryptAES, getCodeSecurity } from '../../utils/functions';
import {
  apinameUtilitarios,
  GENERIC_MESSAGE_ERROR,
  LOGS_CONFIG,
  LOGS_UPDATE,
  SET_ERROR_LOGS,
  SET_ID_AUDITORY,
  SET_LOAD_AUDITORY,
  SET_STEP_LOGS,
  SET_SUCCESS_LOGS,
  URL_AUDITORY,
} from '../utils/constants';
import { AmplifyApi, converterRequest, isEmpty } from '../utils/functions';

export const setLoadAuditory = (dispatch, isLoading) => {
  dispatch({
    type: SET_LOAD_AUDITORY,
    isLoading,
  });
};

export const updateAuditory = (dispatch, response) => {
  dispatch({
    type: SET_ID_AUDITORY,
    idAuditoria: response.idAuditoria,
    pasoInicialFinalizado: 0,
  });
};

export const resetAuditory = (dispatch) => {
  dispatch({
    type: SET_ID_AUDITORY,
    idAuditoria: '',
    pasoInicialFinalizado: 1,
  });
};

export const updateStepLog = (dispatch, data) => {
  dispatch({
    type: SET_STEP_LOGS,
    step: {
      paso: data.paso,
      pasoDescripcion: data.pasoDescripcion,
    },
  });
};

export const logsConfig = (dispatch, data) => {
  dispatch({
    type: LOGS_CONFIG,
    auditoria: {
      placa: data.placa,
      tipoDocumento: data.tipoDocumento,
      numeroDocumento: data.numeroDocumento,
      codigoExterno: data.codigoExterno,
      producto: data.producto,
      codigoProducto: data.codigoProducto,
      idAuditoria: data.idAuditoria,
      idLead: data.idLead,
      correo: data.correo,
      telefono: data.telefono,
      proteccionDatos: data.proteccionDatos,
      comunicacionComercial: data.comunicacionComercial,
      pasoInicialFinalizado: data.pasoInicialFinalizado,
      origen: data.origen,
      device: data.device,
    },
  });
};

export const setSuccessLog = (dispatch, data) => {
  dispatch({
    type: SET_SUCCESS_LOGS,
    servicios: {
      paso: data.paso,
      pasoDescripcion: data.pasoDescripcion,
      urlServicio: data.urlServicio,
      urlCliente: data.urlCliente,
      respuestaExito: JSON.stringify(data.respuestaExito),
      request: JSON.stringify(data.request),
    },
  });
};

export const setErrorLog = (dispatch, data) => {
  dispatch({
    type: SET_ERROR_LOGS,
    servicios: {
      paso: data.paso,
      pasoDescripcion: data.pasoDescripcion,
      urlServicio: data.urlServicio,
      urlCliente: data.urlCliente,
      respuestaError: JSON.stringify(data.respuestaError),
      request: JSON.stringify(data.request),
    },
  });
};

/* eslint-disable import/prefer-default-export */
export const logsAuditory = async (dispatch, auditory, log) => {
  try {
    const requestAuditory = {
      ...auditory,
      ...log,
    };

    if (window.pasoInicialFinalizado === 1) {
      requestAuditory.pasoInicialFinalizado = window.pasoInicialFinalizado;
      delete window.pasoInicialFinalizado;
    }

    if (!requestAuditory.idAuditoria) {
      delete requestAuditory.idAuditoria;
    }
    if (!requestAuditory.respuestaError) {
      delete requestAuditory.respuestaError;
    }
    if (!requestAuditory.respuestaExito) {
      delete requestAuditory.respuestaExito;
    }

    if (GENERIC_MESSAGE_ERROR.some((message) => requestAuditory.respuestaError?.includes(message))) {
      return;
    }

    const { response } = await AmplifyApi({
      name: apinameUtilitarios,
      path: URL_AUDITORY,
      data: converterRequest({
        hash: encryptAES(JSON.stringify(requestAuditory), getCodeSecurity()),
        origenDatos: true,
      }),
    });

    const payload = JSON.parse(
      decryptAES(response.payload?.hash, getCodeSecurity()),
    );

    if (payload.idAuditoria !== window.idAuditoria) {
      window.idAuditoria = payload.idAuditoria;
      window.pasoInicialFinalizado = 1;
      updateAuditory(dispatch, payload);
    }
    return window.idAuditoria;
  } catch (error) {
    setLoadAuditory(dispatch, false);
  }
};

export const sliceLogs = (dispatch, logs) => {
  dispatch({
    type: LOGS_UPDATE,
    logs,
  });
};

export const sendLogsAuditory = async (dispatch, data, logs) => {
  const auditory = { ...data };
  if (logs.length >= 1) {
    const [first, ...others] = logs;
    const idAuditoria = await logsAuditory(dispatch, auditory, first);

    if (!isEmpty(idAuditoria)) {
      others.forEach((log) => {
        logsAuditory(
          dispatch,
          {
            ...auditory,
            idAuditoria,
          },
          log,
        );
      });
    }
  }
};
